import { useState } from "react";
import { useSelector } from "react-redux";
import { isLoadingSelector } from "store1/advance data/advanceData.slice";
import VendorsList from "./VendorList/vendorsList";

const VendorsListWrapper = () => {
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const isLoading = useSelector(isLoadingSelector);
    return (
        <VendorsList
            isLoading={isLoading}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            pageSize={pageSize}
            setPageSize={setPageSize}
        />
    );
};

export default VendorsListWrapper;